import React from 'react';
import classnames from 'classnames';

import Show from 'components/Show';
import Menu from 'components/Ui/Menu';
import Icon from 'components/Misc/Icon';

const Selector = ({ selected, onToggleAll, onTogglePage }) => {
	// Element's classnames
	const selectorClassName = classnames(
		'w-5 h-5 rounded-md border border-neutral-200 dark:border-neutral-700 flex items-center justify-center cursor-pointer transition-colors'
	);

	// Element's classnames
	const expandClassName = classnames(
		'w-3 h-5 flex items-center justify-center cursor-pointer transition-colors'
	);

	return (
		<div className="flex items-center space-x-0.5">
			<div className={selectorClassName} onClick={onTogglePage}>
				<Show if={selected}>
					<Icon icon="remove" className="text-xs text-neutral-400 dark:text-neutral-500" />
				</Show>
			</div>

			<Menu
				placement="bl"
				handler={({ onClick }) => (
					<div className={expandClassName} onClick={onClick}>
						<Icon icon="expand_more" className="text-xs text-neutral-400 dark:text-neutral-500" />
					</div>
				)}
				options={[
					{ text: 'Visus', onClick: onToggleAll },
					{ text: 'Visus dotajā lapā', onClick: onTogglePage }
				]}
			/>
		</div>
	);
};

export default Selector;